import { Component, OnInit , ChangeDetectionStrategy } from '@angular/core';
import { CommonService } from '../../core/services/common.service';

@Component({
    selector: 'app-date-operations',
    templateUrl: './date-operations.component.html',
    styleUrls: ['./date-operations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateOperationsComponent implements OnInit {
  private dateNow = new Date();

  constructor(private cmsSer: CommonService) { }

  ngOnInit(): void {
    // This is intentional
  }

  getStartEndMaxDates() {
    let yearNow = this.dateNow.getFullYear();
    let monthNow = this.dateNow.getMonth() + 1;
    let dayNow = this.dateNow.getDate();
    let hourNow = this.dateNow.getUTCHours();
    let minutesNow = this.dateNow.getUTCMinutes();
    let secondsNow = this.dateNow.getUTCSeconds();
    let next_time = hourNow;
    let min = (minutesNow < 10) ? "0" + minutesNow : minutesNow;
    let isZeroStart = (hourNow < 10) ? "0" : '';
    let isZeroEnd = (next_time < 10) ? "0" : '';
    let start_time: any = (((hourNow - 1) == 9) ? '0' : isZeroStart) + (hourNow - 1) + ":" + min;
    let end_time: any = isZeroEnd + next_time + ":" + min;
    let maxDate = { year: yearNow, month: monthNow, day: dayNow };
    let startEndMaxDates = {
      'yearNow': yearNow,
      'monthNow': monthNow,
      'dayNow': dayNow,
      'hourNow': hourNow,
      'minutesNow': minutesNow,
      'startTime': start_time,
      'endTime': end_time,
      'maxDate': maxDate
    };
    return startEndMaxDates;
  }

  getUsNonUsDateFormat() {
    if (this.cmsSer.getIsUsnjServer() != -1) {
      return 'dd-MM-yyyy HH:mm:ss';
    } else {
      return 'MM-dd-yyyy HH:mm:ss';
    }
  }

  getAllDatePropValues(date) {
    let yearNow = date.getUTCFullYear();
    let monthNow = date.getUTCMonth() + 1;
    let dayNow = date.getUTCDate();
    let hourNow = date.getUTCHours();
    let minutesNow = date.getUTCMinutes();
    let secondsNow = date.getUTCSeconds();
    let next_time = (hourNow + 1);
    let min = (minutesNow < 10) ? "0" + minutesNow : minutesNow;
    let isZeroStart = (hourNow < 10) ? "0" : '';
    let isZeroEnd = (next_time < 10) ? "0" : '';
    let start_time: any = isZeroStart + hourNow + ":" + min;
    let end_time: any = isZeroEnd + next_time + ":" + min;
    let maxDate = { year: yearNow, month: monthNow, day: dayNow };
    let allDatePropValues = {
      'yearNow': yearNow,
      'monthNow': monthNow,
      'dayNow': dayNow,
      'hourNow': hourNow,
      'minutesNow': minutesNow,
      'startTime': start_time,
      'endTime': end_time,
      'maxDate': maxDate,
      'minDate': maxDate
    };
    return allDatePropValues;
  }

  convertToNumOfDays(startTimeStamp, endTimeStamp) { // returns the number of days between to given time stamps
    let timeDifference = Math.abs(endTimeStamp - startTimeStamp);
    let daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    return daysDifference;
  }
  compareWithTime(currentDate) {
    let date = new Date();
    let yearNow = date.getUTCFullYear();
    let monthNow = (date.getUTCMonth() + 1) < 10 ? "0" + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1;
    let dayNow = date.getUTCDate();
    let hourNow = date.getUTCHours();
    let minutesNow = date.getUTCMinutes();
    let secondsNow = date.getUTCSeconds();

    let dateStr = yearNow + "-" + monthNow + "-" + dayNow + "T" + hourNow + ":" + minutesNow + ":00";
    let gmtDate = new Date(dateStr).getTime();

    //let selected = "2024-07-24T12:27:00"
    let newSelectedDate = new Date(currentDate).getTime();
    if (newSelectedDate < gmtDate) {
      return true;
    } else {
      return false;
    }
  }
  convertToYyyyMmDd(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }
}
